module.exports = __webpack_public_path__ + "img/4.45465277.png";